/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Box, Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, styled, Typography } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import DialogGeneric from 'components/dialog/DialogGeneric';
import DialogTextField from 'components/dialog/DialogTextField';
import { IDiagnosticManagementStateProps, SurveyListLatestContent } from 'interface/project/projectInfo';
import FileUpload from 'components/project/enter-information/FileUpload';
import DiagnosticHistoryTable from '../DiagnosticHistoryTable';

const GridItem = styled(Grid)(() => ({
  paddingTop: '0px!important',
}));

interface IDiagnosticFormProps {
  dataInfo: SurveyListLatestContent;
  formData: IDiagnosticManagementStateProps;
  setFormData: React.Dispatch<React.SetStateAction<IDiagnosticManagementStateProps>>;
  handleFileReset: () => void;
  handleFileChange: ({ file, rows }: { file: File; rows: any[][] }) => void;
  id: string;
  type: 'modify' | 'regist';
}

function DiagnosticForm({
  dataInfo,
  formData,
  setFormData,
  handleFileReset,
  handleFileChange,
  id,
  type,
}: IDiagnosticFormProps): JSX.Element {
  const handleFormDataChange = (name: string, value: string) => {
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleDialgnosticFormFileChange = async ({ file, rows }: { file: File; rows: any[][] }) => {
    await handleFileReset();
    handleFileChange({ file, rows });
  };

  return (
    <>
      <GridItem item xs={10}>
        <DialogTextField
          label="진단명"
          text={type === 'modify' ? dataInfo.surveyName : formData.surveyName}
          variant="outlined"
          name="surveyName"
          disabled={type === 'modify'}
          onChange={e => handleFormDataChange('surveyName', e.target.value)}
        />
      </GridItem>
      <GridItem item xs={10} sm={10} md={8}>
        <FileUpload
          type="template3"
          label="진단 문항"
          onReset={handleFileReset}
          onChange={handleDialgnosticFormFileChange}
        >
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mr: 2 }}>
            {formData.surveyFileName.saveFileName ? (
              <Typography>{formData.surveyFileName.saveFileName}</Typography>
            ) : (
              '파일을 선택해주세요'
            )}
          </Box>
        </FileUpload>
      </GridItem>
      <GridItem item xs={10} sm={10} md={2} alignItems="flex-start" justifyContent="center" sx={{ display: 'flex' }}>
        <Button
          color="primary"
          variant="outlined"
          sx={{
            width: '100%',
            height: 41,
            textWrap: 'nowrap',
            '&:hover': {
              backgroundColor: 'transparent',
              border: '1px solid rgba(49, 84, 234, 0.5)',
              cursor: 'default',
            },
          }}
        >
          {formData.surveyFileName?.rowCount || 0}문항
        </Button>
      </GridItem>
      <GridItem item xs={10}>
        <DialogGeneric label="진단 유형">
          <FormControl>
            <RadioGroup
              row
              value={type === 'regist' ? formData.surveyType : dataInfo.surveyType}
              aria-labelledby="type"
              name="row-radio-buttons-group"
              onChange={e => handleFormDataChange('surveyType', e.target.value)}
            >
              <FormControlLabel value="ID" control={<Radio disabled={type === 'modify'} />} label="개별진단" />
              <FormControlLabel
                value="ME"
                control={<Radio disabled={type === 'modify'} />}
                label="다면진단 팀원"
                disabled
              />
            </RadioGroup>
          </FormControl>
        </DialogGeneric>
      </GridItem>
      <GridItem item xs={10}>
        <DialogTextField
          label="수정 내역"
          text={formData.surveyDesc}
          variant="outlined"
          name="surveyDesc"
          onChange={e =>
            setFormData(prevState => ({
              ...prevState,
              surveyDesc: e.target.value,
            }))
          }
        />
      </GridItem>
      <GridItem item xs={10}>
        <DialogGeneric label="진단 히스토리">&nbsp;</DialogGeneric>
        <CustomCard sx={{ mt: 2 }} content={false} border>
          <DiagnosticHistoryTable id={id || ''} />
        </CustomCard>
      </GridItem>
    </>
  );
}

export default memo(DiagnosticForm);
